<template>
  <div>
    <app-title>
      Audit Log
      <v-btn color="success" @click="$router.go(-1)">Back</v-btn>
    </app-title>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" label="Filter" single-line hide-details></v-text-field>
      </v-card-title>

      <v-card-text>
        <v-data-table :headers="headers" :items="logs" :search="search" item-key="date">
          <template slot="items" slot-scope="props">
            <tr>
              <td colspan="5">
                <b>{{props.item['date'].toLocaleDateString()}}</b>
              </td>
            </tr>

            <tr v-for="log in props.item.items" :key="log.id" :class="'ma-0'">
              <td
                :class="'text-xs-center'"
                v-for="col in headers"
                :key="col.value"
              >{{log[col.value]}}</td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="warning">There are no calls recorded</v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import globalMixin from "@/mixins/globalMixin";
export default {
  name: "AuditLog",
  mixins: [globalMixin],
  data() {
    return {
      search: "",
      pagination: {
        sortBy: "start"
      },
      logs: [
        {
          date: new Date("10/04/2019"),
          items: [
            {
              id: 1624923,
              customerNo: "504043",
              domain: "500134.70.vonex.biz",
              dealerId: 2034,
              loginIP: "192.168.1.254",
              timestamp: "1557099095.612",
              changes: [
                { extension: { newValue: 500, oldValue: 502 } },
                { serviceFlag: { newValue: 500, oldValue: 502 } },
                { extension: { newValue: "Jo Blogs", oldValue: "Jane Blogs" } }
              ]
            },
            {
              id: 1624924,
              customerNo: "504043",
              domain: "melbOffice.70.vonex.biz",
              dealerId: 2034,
              loginIP: "192.168.1.254",
              timestamp: "1557099095.612",
              changes: [
                { extension: { newValue: 500, oldValue: 505 } },
                { serviceFlag: { newValue: "manual", oldValue: "automatic" } },
                { extension: { newValue: "Jo Blogs", oldValue: "Jane Blogs" } }
              ]
            },
            {
              id: 1624925,
              customerNo: "504043",
              domain: "perthOffice.70.vonex.biz",
              dealerId: 2034,
              loginIP: "192.168.1.254",
              timestamp: "1557099095.612",
              changes: [
                { extension: { newValue: 500, oldValue: 502 } },
                { serviceFlag: { newValue: 500, oldValue: 502 } },
                { extension: { newValue: "Jo Blogs", oldValue: "Jane Blogs" } }
              ]
            }
          ]
        },
        {
          date: new Date("04/05/2019"),
          items: [
            {
              id: 1624926,
              customerNo: "504043",
              domain: "500134.70.vonex.biz",
              dealerId: 2034,
              loginIP: "192.168.1.254",
              timestamp: "1557099095.612",
              changes: [
                { extension: { newValue: 500, oldValue: 502 } },
                { serviceFlag: { newValue: 500, oldValue: 502 } },
                { extension: { newValue: "Jo Blogs", oldValue: "Jane Blogs" } }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    headers() {
      return this.getHeaders(this.logs[0].items[0]);
    }
  },
  methods: {
    groupByDate() {
      var dateArr = Object.values(
        list.reduce((result, { date, type, amount }) => {
          // Create new group
          if (!result[date])
            result[date] = {
              date,
              activities: []
            };
          // Append to group
          result[date].activities.push({
            type,
            amount
          });
          return result;
        }, {})
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>